import { apiUrls } from '../../../constants/apiUrl';
import logger from '../ErrorBoundary/logger_new';
import { getSession, setSession, isWHW, isWWM, isWHWP2 } from './index';

export const checkCartidAndLQResponse = (pageName) => {
  const isWHWFlag = isWHW() || isWHWP2();
  const isWWMlag = isWWM();
  if (!isWHWFlag && !isWWMlag) {
    const LQResponseData = JSON.parse(getSession('LQResponse'));
    const cartId = getSession('cartExist');
    const emailFlow = getSession('emailFlow');
    if (
      emailFlow !== 'Y' &&
      (LQResponseData === null ||
        LQResponseData === undefined ||
        cartId === '' ||
        cartId === null ||
        cartId === undefined ||
        cartId === 'N' ||
        cartId === 'n')
    ) {
      logger({
        json: true,
        eventType: 'FeInfo',
        message: 'CartId or LQResponse is not available in Session',
        note: `Session Empty on ${pageName} Page`,
        messageType: 'INFO',
      });
      setSession('emptyCartLQ', 'Y');
      window.location.href = apiUrls().redirect5Ghome;
    } else if (emailFlow === 'Y' && (cartId === '' || cartId === null || cartId === undefined || cartId === 'N' || cartId === 'n')) {
      logger({
        json: true,
        eventType: 'FeInfo',
        message: 'CartId is not available in Session',
        note: `Session Empty on ${pageName} Page`,
        messageType: 'INFO',
      });
      setSession('emptyCartLQ', 'Y');
      window.location.href = apiUrls().redirect5Ghome;
    }
  }
};

export const checkInvalidCaseCartError = (response) => {
  if (response && response?.[0]?.id && window.vzFlags.invalidCaseStatusCode && window.vzFlags.invalidCaseStatusCode.includes(response?.[0]?.id)) {
    return true;
  }
  return false;
};

export const redirectToHomePage = () => {
  window.sessionStorage.clear();
  window.localStorage.clear();
  setSession('isTransExpiryRetry', 'Y');
  window.location.href = `${apiUrls().redirect5Ghome}?retryFlow=true`;
};
